<template>
  <div class="PerformancePopupWindow popupWindow">
    <div class="floatingBlock">
      <h3>Optimal performance</h3>
      <p v-if="!supported">Your browser is currently not supported. Please use <a href="https://www.google.co.uk/chrome" target="_blank">Chrome</a> or <span v-if="operatingSystem !== 'Windows'"><a href="https://www.mozilla.org/firefox" target="_blank">Firefox</a></span><span v-else><a href="https://www.microsoft.com/edge" target="_blank">Edge</a></span></p>
      <p></p>
      <div class="row">
        <div class="col-xl-6">
          <h5>Recommended System Specs:</h5>
          <ul>
            <li>64-bit operating system</li>
            <li>8GB of RAM or higher</li>
            <li>Dedicated NVIDIA/AMD GPU (Geforce 400 or Radeon HD 7000 Series or higher)</li>
            <li>Quad-core Intel/AMD CPU (Intel Sandy Bridge or AMD Bulldozer Series or higher)</li>
            <li>Internet Speed - 10mb Download</li>
          </ul>
        </div>
        <div class="col-xl-6">
          <h5>Minimum System Specs:</h5>
          <ul>
            <li>64-bit operating system</li>
            <li>4GB of RAM</li>
            <li>Integrated graphics with WebGL 2.0 / OpenGL ES 3.0 Support</li>
            <li>Dual-core Intel/AMD CPU</li>
            <li>Internet Speed - 5mb Download</li>
          </ul>
        </div>
      </div>
      <p>If your device doesn’t meet the minimum spec, you will not be granted access to the Ultimaker Platform 3D Immersive Showroom, however you can still join the live webinar and Q&amp;A sessions. </p>
      <button @click="closePopup()">Close</button>
    </div>
  </div>
</template>

<script>
const Bowser = require("bowser");
const currentBrowser = Bowser.getParser(window.navigator.userAgent);

export default {
  name: "PerformancePopupWindow",
  components: {
  },
  data: () => ({
    supported: true,
    browser: "",
    browserVersion: "",
    operatingSystem: "",
  }),
  methods: {
    closePopup(){
      this.$store.commit('popup/popupCommit', {
        currentPopup: ''
      })
    }
  },
  created() {
    this.browser = currentBrowser.getBrowserName()
    this.browserVersion = currentBrowser.getBrowserVersion()
    this.operatingSystem = currentBrowser.getOSName()
    if(this.operatingSystem === "iOS" || this.operatingSystem === "iPadOS" || this.operatingSystem === "Android"){
      this.supported = false
    } else if (this.browser === "Firefox"){
      if(this.operatingSystem === "Windows") {
        this.supported = false
      }
    } else if (this.browser === "Microsoft Edge") {
      if(this.browserVersion >=	"83") {
        this.supported = true
      } else {
        this.supported = false
      }
    } else if(this.browser === "Safari"){
      this.supported = false
    } else if (this.browser === "Chrome"){
      // this.supported = false
    }
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/Popups/styles";
</style>
